import { Component, OnInit, ViewChild } from '@angular/core';

import { TranslateParser, TranslateService } from '@ngx-translate/core';

import { ToastsManager } from "@app/shared/util/toastr.service";

import { EquipmentService } from 'app/core/services/equipment.service';
import { Equipment } from 'app/shared/models/equipment.model';

import { TableConfig } from 'app/shared/util/table-config.utils';

import { EquipmentCreateModalComponent } from './components/equipment-create-modal/equipment-create-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Log } from "ng2-logger";
import { PermissionService } from "@app/authentication/services/permission.service";
import { AppUtils } from "@app/shared/util/app.utils";
import * as FileSaver from "file-saver";
import { HttpResponse } from "@angular/common/http";

@Component({
    selector: 'app-equipment',
    templateUrl: './equipment.component.html',
    styleUrls: ['./equipment.component.scss']
})
export class EquipmentManagementComponent implements OnInit {

    @ViewChild(EquipmentCreateModalComponent, {static: true}) equipmentFormModal: EquipmentCreateModalComponent;

    equipment: Equipment[] = [];
    tableConfig = new TableConfig();
    isLoadingEquipment = false;
    _logger = Log.create(EquipmentManagementComponent.name);

    constructor(private equipmentService: EquipmentService,
                private router: Router,
                private route: ActivatedRoute,
                private permissionService: PermissionService,
                private toastr: ToastsManager,
                private translationService: TranslateService,
                private translateParser: TranslateParser) {
    }

    ngOnInit() {
        this.getEquipment(this.tableConfig);
    }


    onFilter(tableConfig: TableConfig) {
        this.getEquipment(tableConfig);
    }

    onPageChange(tableConfig: TableConfig) {
        this.getEquipment(tableConfig);
    }

    openEquipmentModal() {
        this.equipmentFormModal.open();
    }

    onDuplicateRow(equipment) {
        this._logger.info('onDuplicateRow::', equipment);
        equipment.name = equipment.name + AppUtils.COPY_STRING;
        this.equipmentFormModal.open(equipment, true);
    }

    manageProcessTypes() {
        this.router.navigate(['process-types-management'], {relativeTo: this.route});
    }

    getEquipment(tableConfig = this.tableConfig) {
        this.isLoadingEquipment = true;
        this.equipmentService.getAllEquipment(tableConfig).subscribe(data => {
                this.equipment = data.equipment;
                this.tableConfig.pager.count = data.count;
                this.isLoadingEquipment = false;
            },
            (error: any) => {
                this.isLoadingEquipment = false;
            });
    }

    createEquipment(equipment) {
        this.isLoadingEquipment = true;
        this.equipmentService.createEquipment(equipment).subscribe(
            (data: any) => {
                this.getEquipment();
                this.toastr.success(this.buildCreateMessage(data.name));
                this.isLoadingEquipment = false;
                this.equipmentFormModal.close();
            },
            (error: any) => {
                this._logger.error('onCreateEquipment:: API Returned error', error);
                this.isLoadingEquipment = false;
            }
        );
    }

    updateEquipment(equipmentUpdate) {
        this.isLoadingEquipment = true;
        this.equipmentService.updateEquipment(equipmentUpdate.newEquipment).subscribe(
            (data: any) => {
                this.getEquipment();
                this.toastr.success(this.buildUpdateMessage(equipmentUpdate.previousEquipmentName));
                this.isLoadingEquipment = false;
                this.equipmentFormModal.close();
            },
            (error: any) => {
                this._logger.error('onUpdateEquipment:: API Returned error', error);
                this.isLoadingEquipment = false;
            }
        );
    }

    deleteEquipment(equipment) {
        this.isLoadingEquipment = true;
        this.equipmentService.deleteEquipment(equipment).subscribe(
            (data: any) => {
                this.getEquipment();
                this.toastr.warning(this.buildDeleteMessage(equipment.name));
                this.isLoadingEquipment = false;
                this.equipmentFormModal.close();
            },
            (error: any) => {
                this._logger.error('onDeleteEquipment:: API Returned error', error);
                this.isLoadingEquipment = false;
            }
        );
    }

    buildCreateMessage(equipmentName) {
        const message = this.translationService.instant('admin.equipment.toasts.created');
        return this.translateParser.interpolate(message, {equipmentName: equipmentName});
    }

    buildUpdateMessage(equipmentName) {
        const message = this.translationService.instant('admin.equipment.toasts.updated');
        return this.translateParser.interpolate(message, {equipmentName: equipmentName});
    }

    buildDeleteMessage(equipmentName) {
        const message = this.translationService.instant('admin.equipment.toasts.deleted');
        return this.translateParser.interpolate(message, {equipmentName: equipmentName});
    }

    onSortChange(tableState) {
        this.getEquipment(tableState);
    }

    onTableRowClick(equipment: Equipment) {
        this.equipmentFormModal.open(equipment);
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('MANAGE_EQUIPMENT');
    }

    onDownloadEquipReport(tableConfig = this.tableConfig) {
        this.equipmentService.downloadEquipReport(tableConfig).subscribe(
            (data: HttpResponse<any>) => {
                if (data.body != null) {
                    this._logger.info('onDownloadEquipReport:: API Returned data', data);
                    const blob = new Blob([data.body], {type: 'application/xsls'});
                    const filename = data.headers.get('x-filename');
                    FileSaver.saveAs(blob, filename);
                }
            },
            (error: any) => {
                this._logger.error('onDownloadEquipReport:: API Returned error', error);
            });
    }
}


